import Request from '../../../../src/core/gd/data/request'

export default class ApiTaskMessage {

    constructor() {

    }

    // UPDATE
    // updates message only
    static updateMessage(taskId: ID, taskMessageId: ID, message: string, messageRTF: any) {
        return new Request(this,'PUT','task/'+taskId+"/message/"+taskMessageId,{
            message     : message,
            messageRTF  : messageRTF
        })
    }

    static addReaction(taskID: ID, messageID: ID, reactionType: any) {

        return new Request(this,'POST','task/' + taskID + '/message/' + messageID +'/reactions',{
            reactionType: reactionType
        });
    }

    static deleteReaction(taskID: ID, messageID: ID, reactionType: any) {

        return new Request(this,'DELETE','task/' + taskID + '/message/' + messageID +'/reactions?reactionType='+reactionType)
    }

}